import { render } from "./Detail.vue?vue&type=template&id=e680b15c&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=e680b15c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e680b15c"

export default script